import { EntityUpdater } from "./EntitiyUpdater";

export class PlayerUpdater extends EntityUpdater {
    constructor(data, teamApiData, teamType, component) {
        super(data);
        this.teamApiData = teamApiData;
        this.teamType = teamType;
        this.coreSquad = component === "coresquad";
        this.squad = component === "squad";
        this.starting = data.numberOfStartingPlayers;
        this.teamStartingCounters = {};
    }

    initializeStartingCounters(allMatchPlayers) {
        this.teamStartingCounters = {};

        Object.values(allMatchPlayers).forEach((player) => {
            if (player.isStartingPlayer) {
                const teamId = player.team;
                if (!this.teamStartingCounters[teamId]) {
                    this.teamStartingCounters[teamId] = 0;
                }
                this.teamStartingCounters[teamId]++;
            }
        });
    }

    updatePlayers(adding, deleting) {
        let { allMatchPlayers, allTeamPlayers } = this.data;

        if (deleting.length > 0) {
            if (this.coreSquad || this.squad) {
                allTeamPlayers = this.processDeletions(
                    deleting,
                    allTeamPlayers
                );
            } else {
                allMatchPlayers = this.processDeletions(
                    deleting,
                    allMatchPlayers
                );
            }
        }

        if (adding.length > 0) {
            if (this.coreSquad || this.squad) {
                allTeamPlayers = this.processAdditions(
                    adding,
                    allTeamPlayers,
                    (item, index) => {
                        return {
                            contact: item.id,
                            number: item.shirtNumber || "",
                            isGoalkeeper: !!item.isGoalkeeper,
                            isSubstituteGoalkeeper:
                                !!item.isSubstituteGoalkeeper,
                            isCaptain: !!item.isCaptain,
                            passport: item.passportNumber,
                            team: this.data.id,
                            core: this.coreSquad,
                            isStartingPlayer: this.starting < index,
                        };
                    }
                );
            } else {
                this.initializeStartingCounters(allMatchPlayers);

                allMatchPlayers = this.processAdditions(
                    adding,
                    allMatchPlayers,
                    (item) => {
                        if (!this.teamStartingCounters[this.teamType]) {
                            this.teamStartingCounters[this.teamType] = 0;
                        }

                        const isStartingPlayer =
                            this.teamStartingCounters[this.teamType] <
                            this.starting;

                        if (isStartingPlayer) {
                            this.teamStartingCounters[this.teamType]++;
                        }

                        return {
                            contact: item.id,
                            number: this.teamApiData.allTeamPlayers[item.id]
                                ?.number,
                            isGoalkeeper:
                                this.teamApiData.allTeamPlayers[item.id]
                                    ?.isGoalkeeper,
                            isSubstituteGoalkeeper:
                                this.teamApiData.allTeamPlayers[item.id]
                                    ?.isSubstituteGoalkeeper,
                            isCaptain:
                                this.teamApiData.allTeamPlayers[item.id]
                                    ?.isCaptain,
                            passport: item.passportNumber,
                            team: this.teamType,
                            core: this.coreSquad,
                            isStartingPlayer: isStartingPlayer,
                        };
                    }
                );
            }
        }

        this.data = {
            ...this.data,
            allMatchPlayers,
            allTeamPlayers,
            isSquadChange: true,
        };

        return this.data;
    }
}
